import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Home from "../components/Home/Home";
import Footer from "../components/Footer/Footer";
import Header from "../components/Header/Header";
import ServicePage from "../components/Services/ServicesPage";
import Services from "../components/Services/Services";
import Process from "../components/Process/Process";
import Strategies from "../components/Strategies/Strategies";
import About from "../components/About/About";
import Contact from "../components/Contact/Contact";
import PrivacyPolicy from "../components/PrivacyPolicy/PrivacyPolicy";
import Terms from "../components/Terms/Terms";
import Disclaimer from "../components/Disclaimer/Disclaimer";
import RefundPolicy from "../components/RefundPolicy/RefundPolicy";
import ShippingPolicy from "../components/ShippingPolicy/ShippingPolicy";
import SiteDisclaimer from "../components/SiteDisclaimer/SiteDisclaimer";

const ScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return null;
};


const MainContent = ({ children }) => {
  const location = useLocation();

  
  const isAdjustedRoute = ["/services", "/about", "/contact"].includes(location.pathname);


  const style = isAdjustedRoute
    ? { minHeight: "60vh", display: "flex", flexDirection: "column" }
    : {};

  return <div style={style}>{children}</div>;
};


const AppContent = () => {
  const location = useLocation();

  return (
    <>
      <ScrollToTop />
      <Header />
      <MainContent>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services/:serviceId" element={<ServicePage />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/services" element={<Services />} />
          <Route path="/process" element={<Process />} />
          <Route path="/our-strategies" element={<Strategies />} />
          <Route path="/disclaimer" element={<Disclaimer />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-and-conditions" element={<Terms />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />
          <Route path="/shipping-policy" element={<ShippingPolicy />} />
        </Routes>
      </MainContent>
      {location.pathname !== "/disclaimer" && <SiteDisclaimer />}
      <Footer />
    </>
  );
};

const Container = () => {
  return (
    <Router >
      <AppContent uniqueKey="webantidigi.com" />
    </Router>
  );
};

export default Container;
